export const isPageOutOfRange = (page: number, total: number, pageSize: number): boolean =>
    page > Math.max(1, Math.ceil(total / pageSize));
